import appData from '../../config/App_data';
import GetData from '../../RestAPI/getDataService';

const fetchChaptersWithPremiumAndFreeCount = async (data) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/frm/notes/notes-wise-count`, data);
};

const downloadFormulaSheet = async (data) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/frm/notes/additional-resources`, data);
};
const fetchLastNoteRead = async (data = {}) => {
  return await GetData.callAPI(`${appData.backend_api}/exams/frm/notes/last-notes-answered`, data);
};
module.exports = {
  fetchChaptersWithPremiumAndFreeCount,
  fetchLastNoteRead,
  downloadFormulaSheet,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Notes/ApiService.js